import { useQuery } from "@tanstack/react-query";
import { convexQuery } from "@convex-dev/react-query";
import { api } from "@constructionautomation/backend";

import {
  describePaidInvite,
  describeReviewerAllowance,
  type ReviewerAllowance,
  type SeatBillingPreview,
} from "./member-change-copy";

export type InviteRole = "member" | "admin" | "reviewer";

export type InviteBillingImpact =
  | { kind: "reviewer"; reviewerSeats: ReviewerAllowance }
  | (SeatBillingPreview & { kind: "paid_seat" });

export function describeInviteBillingImpact(impact: InviteBillingImpact) {
  if (impact.kind === "reviewer") return `Free. ${describeReviewerAllowance(impact.reviewerSeats)}`;
  return describePaidInvite(impact);
}

/**
 * What inviting someone with `role` means for billing (`members.getInviteBillingImpact`), ready
 * for <SeatBillingNotice>. `blocked` is true while a scheduled cancellation blocks paid seats;
 * the server rejects the invitation then too (PAID_SEAT_BLOCKED_PENDING_CANCELLATION).
 */
export function useInviteBillingImpact(role: InviteRole, options: { enabled?: boolean } = {}) {
  const { data: impact } = useQuery(
    convexQuery(api.members.getInviteBillingImpact, options.enabled === false ? "skip" : { role })
  );
  return {
    impact,
    message: impact ? describeInviteBillingImpact(impact) : null,
    blocked: impact?.kind === "paid_seat" && impact.billingConsequence === "blocked_pending_cancellation",
  };
}
